module.exports = "<div class=wrapper> <navbar></navbar> <div class=container> <div class=row> <div class=col-md-12> <router-view></router-view> </div> </div> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 49
 ** module chunks = 0
 **/